import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  
  constructor(private localStorage: LocalStorageService,private router: Router,private toastrServices:ToastrService) {}
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Clone the request and add the header
     // Check if the request is sending FormData (file upload)
     let modifiedRequest = request;

     if (request.body instanceof FormData) {
       // If FormData, do not set Content-Type (let Angular handle it)
       modifiedRequest = request.clone({
         setHeaders: {
           'authentication': this.localStorage.get('authentication') || '',
           'session': this.localStorage.get('session') || '',
           // No need to set 'Content-Type' here as Angular will do it for FormData
         }
       });
     } else {
       // For other requests, set Content-Type to 'application/json' (for JSON payload)
       modifiedRequest = request.clone({
         setHeaders: {
           'authentication': this.localStorage.get('authentication') || '',
           'session': this.localStorage.get('session') || '',
           'Content-Type': 'application/json'
         }
       });
     }
 
     // Pass the cloned request instead of the original request to the next handler
     return next.handle(modifiedRequest).pipe(
       catchError((error: HttpErrorResponse) => {
         if (error.status === 401) {
           // Handle unauthorized error
           this.localStorage.clearLocalStorage('');
           this.router.navigate(['/auth/login']);
           this.toastrServices.error('Please Login');
         }
         return throwError(() => error);
       })
     );
   }
 }
